import { formatDate } from '@/lib/formatters'
import type { PolicyChangeAsk } from '@/models/policyChange'

/** The broker's question as they wrote it, with the day they asked. */
export function AskQuestion({ ask }: { ask: PolicyChangeAsk }) {
  return (
    <div className="rounded-md bg-neutral-50 p-3 text-sm">
      <p className="whitespace-pre-line text-neutral-900">{ask.question}</p>
      <p className="mt-1 text-xs text-neutral-500">
        Asked {formatDate(ask.askedAt)}
        {ask.needsDocument && ' · They need a document'}
      </p>
    </div>
  )
}
